// Ozlo Gallery Slider
// Extracted from ozlo-main.js
// REQUIRES: Keen Slider library (https://keen-slider.io/)
// This file must be loaded AFTER keen-slider.js

function initOzloSliders() {
  // Check if KeenSlider is available
  if (typeof KeenSlider === 'undefined') {
    console.error('Ozlo Gallery Slider requires Keen Slider library to be loaded first');
    return;
  }

  document.querySelectorAll('.oz-gallery .ozlo-slider').forEach((gallery, index) => {
    const slider = gallery.querySelector('.slider');
    if (!slider) return;

    // Parse configuration from data attributes
    const config = {
      loop: gallery.dataset.loop === 'true' || gallery.dataset.loop === 'TRUE',
      animationDuration: parseInt(gallery.dataset.animationDuration) || 1000,
      drag: gallery.dataset.allowDrag === 'true',
      rubberband: gallery.dataset.rubberband === 'true',
      animationType: gallery.dataset.animationType || 'scroll',
      complex: gallery.dataset.complex === 'true',
      renderMode: gallery.dataset.rendermode || 'precision',
      autoplay: gallery.dataset.autoplay === 'true',
      slidesPerView: gallery.dataset.slidesPerView || gallery.dataset.perView || '1,1',
      spacing: parseInt(gallery.dataset.spacing) || 60,
      spacingMobile: parseInt(gallery.dataset.spacingMobile) || 20
    };

    // Auto-play settings override other settings
    let autoplayInterval = 0;
    if (config.autoplay) {
      autoplayInterval = 3000;
      config.loop = true;
      config.drag = false;
      config.renderMode = 'performance';
    }

    // Animation type 'none' means no duration
    if (config.animationType === 'none') {
      config.animationDuration = 0;
    }

    // Check if custom slide widths are defined via data attributes
    const hasCustomSlideWidth = gallery.dataset.slideWidth || gallery.dataset.slideWidthMobile;

    // Parse slides per view (format: "mobile,desktop")
    // Use 'auto' if custom widths are defined, otherwise use numeric values
    let slidesPerViewDesktop, slidesPerViewMobile;

    if (hasCustomSlideWidth) {
      // Use 'auto' to respect CSS-defined widths (--slide-width custom properties)
      slidesPerViewDesktop = 'auto';
      slidesPerViewMobile = 'auto';
    } else {
      const slidesPerViewArray = config.slidesPerView.split(',').map(v => parseFloat(v));
      // Ensure we have at least 2 values (mobile, desktop)
      while (slidesPerViewArray.length < 2) {
        slidesPerViewArray.push(slidesPerViewArray[slidesPerViewArray.length - 1]);
      }
      slidesPerViewDesktop = slidesPerViewArray[1];
      slidesPerViewMobile = slidesPerViewArray[0];
    }

    // Get UI elements
    const controls = gallery.querySelector('.slider__controls, .oz-slider-buttons');
    const navButtons = gallery.querySelectorAll('.slider-nav');

    // Add classes
    slider.classList.add('keen-slider-container');
    const slides = Array.from(slider.children);
    slides.forEach(slide => {
      slide.classList.add('keen-slider__slide');
    });

    // Keen Slider options
    const sliderOptions = {
      selector: '.keen-slider__slide',
      loop: config.loop,
      drag: config.drag,
      rubberband: config.rubberband,
      renderMode: config.renderMode,
      duration: config.animationDuration,
      slides: {
        perView: slidesPerViewDesktop, // Desktop (auto or numeric)
        spacing: config.spacing
      },
      breakpoints: {
        '(max-width: 768px)': {
          slides: {
            perView: slidesPerViewMobile, // Mobile (auto or numeric)
            spacing: config.spacingMobile
          }
        }
      }
    };

    // Animation type handling
    if (config.animationType === 'fade') {
      console.log('animationType fade');
      // Fade animation would require additional Keen Slider plugins
      // Implementation depends on keen-slider version
    }

    // Initialize Keen Slider
    const keenSlider = new KeenSlider(slider, sliderOptions);

    // Auto-play functionality
    let autoplayTimer;
    if (autoplayInterval > 0) {
      const startAutoplay = () => {
        autoplayTimer = setInterval(() => {
          keenSlider.next();
        }, autoplayInterval);
      };

      const stopAutoplay = () => {
        clearInterval(autoplayTimer);
      };

      // Start autoplay
      startAutoplay();

      // Pause on hover
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
    }

    // Navigation button handling
    if (navButtons.length > 0 && controls) {
      gallery.classList.add('slider-nav-visible');

      // Auto-hide nav buttons at start/end
      const hasAutohide = gallery.dataset.autoHideNav === 'true' || gallery.dataset.navAutohide === 'true';
      if (hasAutohide) {
        gallery.classList.add('slider-nav-autohide');
      }

      // Update nav button states
      const updateNavButtons = () => {
        const details = keenSlider.track.details;
        const isFirst = details.rel <= (details.minIdx || 0);
        const isLast = details.rel >= details.maxIdx;

        if (isFirst) {
          gallery.classList.add('slider-item-first-visible');
        } else {
          gallery.classList.remove('slider-item-first-visible');
        }

        if (isLast) {
          gallery.classList.add('slider-item-last-visible');
        } else {
          gallery.classList.remove('slider-item-last-visible');
        }
      };

      // Setup navigation buttons
      navButtons.forEach(button => {
        button.addEventListener('click', () => {
          if (button.classList.contains('slider-nav-next')) {
            if (config.complex) {
              // Complex mode: jump 2 slides if slide is small
              let step = 1;
              const currentSlideSize = keenSlider.track.details.slides[keenSlider.track.details.rel].size;
              if (currentSlideSize * 2 <= 1.001) {
                step = 2;
              }
              keenSlider.moveToIdx(keenSlider.track.details.rel + step);
            } else {
              keenSlider.next();
            }
          } else if (button.classList.contains('slider-nav-prev')) {
            if (config.complex) {
              // Complex mode: jump 2 slides if slide is small
              let step = 1;
              const currentSlideSize = keenSlider.track.details.slides[keenSlider.track.details.rel].size;
              if (currentSlideSize * 2 > 1) {
                step = 2;
              }
              if (keenSlider.track.details.rel - step < 0) {
                keenSlider.moveToIdx(0);
              } else {
                keenSlider.moveToIdx(keenSlider.track.details.rel - step);
              }
            } else {
              keenSlider.prev();
            }
          }
        });
      });

      // Listen for slide changes
      keenSlider.on('slideChanged', updateNavButtons);

      // Initial update
      updateNavButtons();
    }

    // Store reference on nav buttons
    keenSlider.nav = controls;

    // Mark as initialized
    if (keenSlider) {
      gallery.classList.add('keen-inited');
    }
  });
}

// Initialize on page load
window.addEventListener('load', initOzloSliders);
